import {
  EMPLOYEE_SEARCH_REQUEST_FAIL,
  EMPLOYEE_SEARCH_REQUEST_SUCCESS
} from '../action.types'
import initialState from '../initial.state'

export default (state = initialState.searchContractor, action) => {
  switch (action.type) {
    case EMPLOYEE_SEARCH_REQUEST_SUCCESS:
      return [...action.payload]
    case EMPLOYEE_SEARCH_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/employee/searchemployee.reducer.js